module.exports = __webpack_public_path__ + "static/img/bbc-five-live.1716979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/bbc-five-live.png
// module id = Z8mw
// module chunks = 0